import * as $gzBrowser from './browser.service';

export default angular.module('gazelle.components.browser', [
])
  .service($gzBrowser.name, $gzBrowser.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/browser/browser.module.js